import { createFileRoute } from '@tanstack/react-router'
import { ProjectPage } from '@/components/pages/ProjectPage'

export const Route = createFileRoute('/workspace/project/$uuid')({
  component: ProjectPage,
})
